export var BoxSelectionBoxSize;
(function (BoxSelectionBoxSize) {
    BoxSelectionBoxSize["small"] = "small";
    BoxSelectionBoxSize["xLarge"] = "large";
    BoxSelectionBoxSize["xSmall"] = "xsmall";
})(BoxSelectionBoxSize || (BoxSelectionBoxSize = {}));
export var BoxSelectionDataHooks;
(function (BoxSelectionDataHooks) {
    BoxSelectionDataHooks["BOX_SELECTION_WRAPPER"] = "box-selection-wrapper";
    BoxSelectionDataHooks["BOX_SELECTION_OPTION"] = "box-selection-option";
    BoxSelectionDataHooks["BOX_SELECTION_OPTION_WRAPPER"] = "box-selection-option-wrapper";
    BoxSelectionDataHooks["BOX_SELECTION_SUFFIX"] = "box-selection-suffix";
})(BoxSelectionDataHooks || (BoxSelectionDataHooks = {}));
export var BoxSelectionDataAttributes;
(function (BoxSelectionDataAttributes) {
    BoxSelectionDataAttributes["DISABLED"] = "data-disabled";
    BoxSelectionDataAttributes["CHECKED"] = "data-checked";
    BoxSelectionDataAttributes["UNAVAILABLE"] = "data-unavailable";
    BoxSelectionDataAttributes["FOCUSED"] = "data-focused";
    BoxSelectionDataAttributes["NATIVE_SELECTOR"] = "data-native-selector";
})(BoxSelectionDataAttributes || (BoxSelectionDataAttributes = {}));
export var BoxSelectionSelectionType;
(function (BoxSelectionSelectionType) {
    BoxSelectionSelectionType["RADIO_BUTTON"] = "radioButton";
    BoxSelectionSelectionType["CHECKBOX"] = "checkBox";
})(BoxSelectionSelectionType || (BoxSelectionSelectionType = {}));
//# sourceMappingURL=types.js.map